import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 80,
        height: 80,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1500 935">
        <g transform="matrix(1,0,0,1,-0.9090909090909918,176.26910317752424)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 396 247" data-background-color="#ffffff" preserveAspectRatio="xMidYMid meet" height="935" width="1500">
            <g id="tight-bounds" transform="matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)">
              <svg viewBox="0 0 395.52 247.2" height="247.2" width="395.52">
                <g>
                  <svg viewBox="0 0 395.52 247.2" height="247.2" width="395.52">
                    <g transform="matrix(1,0,0,1,75.54432,76.45683656401945)">
                      <svg viewBox="0 0 244.43135999999998 94.28632687196108" height="94.28632687196108" width="244.43135999999998">
                        <g>
                          <svg viewBox="0 0 244.43135999999998 94.28632687196108" height="94.28632687196108" width="244.43135999999998">
                            <g>
                              <svg viewBox="0 0 244.43136 94.2863268719611" height="94.28632687196108" width="244.43135999999998">
                                <g>
                                  <svg viewBox="0 0 244.43136 94.2863268719611" height="94.2863268719611" width="244.43136">
                                    <g id="textblocktransform">
                                      <svg viewBox="0 0 244.43136 94.2863268719611" height="94.2863268719611" width="244.43136" id="textblock">
                                        <g>
                                          <svg viewBox="0 0 244.43136 94.2863268719611" height="94.2863268719611" width="244.43136">
                                            <g transform="matrix(1,0,0,1,0,0)">
                                              <svg width="244.43136" viewBox="2.8 -35.5 92.55 35.699999999999996" height="94.2863268719611" data-palette-color="#0718c4">
                                                <path
                                                    d="M23.85-22.95L23.85-22.95 23.8-12.95Q23.8-10.75 24.48-9.68 25.15-8.6 27.3-8.6L27.3-8.6 39.95-8.6Q42.25-8.55 42.25-5.1L42.25-5.1Q42.25-2.45 41.6-1.25 40.95-0.05 38.95 0L38.95 0Q31.9 0.2 25 0.2 18.1 0.2 7.4 0.1L7.4 0.1Q5.6 0.1 4.48-0.78 3.35-1.65 3.2-3.2L3.2-3.2Q2.8-7.55 2.8-16.93 2.8-26.3 3.03-29.58 3.25-32.85 3.95-33.93 4.65-35 6.7-35L6.7-35 20.1-35Q22.2-35 22.88-33.9 23.55-32.8 23.7-30.35 23.85-27.9 23.85-22.95ZM78-32.65L78-32.65 94.35-5Q95.35-3.35 95.35-2.23 95.35-1.1 94.45-0.55 93.55 0 92.35 0L92.35 0 76.25 0Q73.8 0 73.1-0.9L73.1-0.9Q72.9-1.2 72.55-1.95L72.55-1.95 71.1-5.05Q70.45-6.5 68.05-6.7L68.05-6.7 58.6-6.7Q57.55-6.7 57-6.5 56.45-6.3 56.1-5.6L56.1-5.6 54.15-1.55Q53.65-0.65 53.05-0.33 52.45 0 51.3 0L51.3 0 46.8 0Q44.85 0 44.7-1.4L44.7-1.4Q44.65-1.6 44.65-1.8L44.65-1.8Q44.65-2.95 45.4-4L45.4-4 61.05-31.6Q63.3-35.5 68.35-35.5L68.35-35.5 72.35-35.5Q76.35-35.5 78-32.65ZM61.8-19.85L61.8-19.85 59.5-15.3Q59.3-14.85 59.3-14.5L59.3-14.5Q59.3-13.2 60.55-13.2L60.55-13.2 65.1-13.2Q66.15-13.2 66.55-13.73 66.95-14.25 66.95-14.65 66.95-15.05 66.8-15.45L66.8-15.45 64.9-19.75Q64.3-21.05 63.35-21.05 62.4-21.05 61.8-19.85Z"
                                                    opacity="1" transform="matrix(1,0,0,1,0,0)" fill="#2065D1"
                                                    className="wordmark-text-0" data-fill-palette-color="primary"
                                                    id="text-0"/>
                                              </svg>
                                            </g>
                                          </svg>
                                        </g>
                                      </svg>
                                    </g>
                                  </svg>
                                </g>
                                <g/>
                              </svg>
                            </g>
                          </svg>
                        </g>
                      </svg>
                    </g>
                    <g>
                      <path
                          d="M97.162 54.198A122.216 122.216 0 0 1 298.358 54.198L289.856 54.198A113.713 113.713 0 0 0 105.664 54.198L97.162 54.198M97.162 193.002A122.216 122.216 0 0 0 298.358 193.002L289.856 193.002A113.713 113.713 0 0 1 105.664 193.002L97.162 193.002"
                          fill="#2065D1" stroke="transparent" data-fill-palette-color="tertiary"/>
                    </g>
                  </svg>
                </g>
                <defs/>
              </svg>
              <rect width="395.52" height="247.2" fill="none" stroke="none" visibility="hidden"/>
            </g>
          </svg>
        </g>
      </svg>

      {/*<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 512">*/}
      {/*  <defs>*/}
      {/*    <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">*/}
      {/*      <stop offset="0%" stopColor={PRIMARY_DARK} />*/}
      {/*      <stop offset="100%" stopColor={PRIMARY_MAIN} />*/}
      {/*    </linearGradient>*/}

      {/*    <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">*/}
      {/*      <stop offset="0%" stopColor={PRIMARY_LIGHT} />*/}
      {/*      <stop offset="100%" stopColor={PRIMARY_MAIN} />*/}
      {/*    </linearGradient>*/}

      {/*    <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">*/}
      {/*      <stop offset="0%" stopColor={PRIMARY_LIGHT} />*/}
      {/*      <stop offset="100%" stopColor={PRIMARY_MAIN} />*/}
      {/*    </linearGradient>*/}
      {/*  </defs>*/}

      {/*  <g fill={PRIMARY_MAIN} fillRule="evenodd" stroke="none" strokeWidth="1">*/}
      {/*    <path*/}
      {/*      fill="url(#BG1)"*/}
      {/*      d="M183.168 285.573l-2.918 5.298-2.973 5.363-2.846 5.095-2.274 4.043-2.186 3.857-2.506 4.383-1.6 2.774-2.294 3.939-1.099 1.869-1.416 2.388-1.025 1.713-1.317 2.18-.95 1.558-1.514 2.447-.866 1.38-.833 1.312-.802 1.246-.77 1.18-.739 1.111-.935 1.38-.664.956-.425.6-.41.572-.59.8-.376.497-.537.69-.171.214c-10.76 13.37-22.496 23.493-36.93 29.334-30.346 14.262-68.07 14.929-97.202-2.704l72.347-124.682 2.8-1.72c49.257-29.326 73.08 1.117 94.02 40.927z"*/}
      {/*    />*/}
      {/*    <path*/}
      {/*      fill="url(#BG2)"*/}
      {/*      d="M444.31 229.726c-46.27-80.956-94.1-157.228-149.043-45.344-7.516 14.384-12.995 42.337-25.267 42.337v-.142c-12.272 0-17.75-27.953-25.265-42.337C189.79 72.356 141.96 148.628 95.69 229.584c-3.483 6.106-6.828 11.932-9.69 16.996 106.038-67.127 97.11 135.667 184 137.278V384c86.891-1.611 77.962-204.405 184-137.28-2.86-5.062-6.206-10.888-9.69-16.994"*/}
      {/*    />*/}
      {/*    <path*/}
      {/*      fill="url(#BG3)"*/}
      {/*      d="M450 384c26.509 0 48-21.491 48-48s-21.491-48-48-48-48 21.491-48 48 21.491 48 48 48"*/}
      {/*    />*/}
      {/*  </g>*/}
      {/*</svg>*/}
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
